import { WindowState } from '../state';
import { SectionType } from '../types';

const SECTION_TYPE_OPTIONS: { value: SectionType; label: string }[] = [
  { value: SectionType.FIX, label: 'Fixed (Vast glas)' },
  { value: SectionType.CAS_IN, label: 'Casement In (Draairaam)' },
  { value: SectionType.CAS_OUT, label: 'Casement Out' },
  { value: SectionType.TT, label: 'Turn-Tilt (Draai-kiepraam)' },
  { value: SectionType.TILT_IN, label: 'Tilt In (Kiepraam)' },
  { value: SectionType.TOPHUNG_OUT, label: 'Top-Hung Out (Klepraam)' },
  { value: SectionType.STOLP, label: 'Meeting Stile (Stolpraam)' },
  { value: SectionType.PIVOT_V, label: 'Pivot (Taatsraam)' },
  { value: SectionType.SLIDE_H, label: 'Slide Horizontal' },
  { value: SectionType.SLIDE_V, label: 'Slide Vertical' },
];

const HINGE_TYPES = new Set([
  SectionType.CAS_IN, SectionType.CAS_OUT, SectionType.TT, SectionType.STOLP,
]);

export function createSectionTypeSelector(
  state: WindowState,
  sectionIndex: number,
): HTMLElement {
  const container = document.createElement('div');
  const config = state.config.sections[sectionIndex];

  // Type dropdown
  const typeRow = document.createElement('div');
  typeRow.className = 'opt-row';

  const typeLabel = document.createElement('span');
  typeLabel.className = 'opt-label';
  typeLabel.textContent = 'Type';

  const typeSelect = document.createElement('select');
  typeSelect.className = 'opt-select';

  for (const opt of SECTION_TYPE_OPTIONS) {
    const option = document.createElement('option');
    option.value = opt.value;
    option.textContent = opt.label;
    if (config.type === opt.value) option.selected = true;
    typeSelect.appendChild(option);
  }

  typeSelect.addEventListener('change', () => {
    state.setSectionType(sectionIndex, typeSelect.value as SectionType);
  });

  typeRow.appendChild(typeLabel);
  typeRow.appendChild(typeSelect);
  container.appendChild(typeRow);

  // Hinge side (only for applicable types)
  if (HINGE_TYPES.has(config.type)) {
    const hingeRow = document.createElement('div');
    hingeRow.className = 'opt-row';

    const hingeLabel = document.createElement('span');
    hingeLabel.className = 'opt-label';
    hingeLabel.textContent = 'Hinge';

    const hingeSelect = document.createElement('select');
    hingeSelect.className = 'opt-select';

    for (const side of ['left', 'right'] as const) {
      const option = document.createElement('option');
      option.value = side;
      option.textContent = side.charAt(0).toUpperCase() + side.slice(1);
      if (config.orientation.hingeSide === side) option.selected = true;
      hingeSelect.appendChild(option);
    }

    hingeSelect.addEventListener('change', () => {
      state.setSectionHinge(sectionIndex, hingeSelect.value as 'left' | 'right');
    });

    hingeRow.appendChild(hingeLabel);
    hingeRow.appendChild(hingeSelect);
    container.appendChild(hingeRow);
  }

  return container;
}
